"use client";

import { useAuth } from "@/components/features/auth/hooks/use-auth";
import { userClient } from "@/lib/connect.client";
import { useCallback, useEffect, useState } from "react";

export type Account = {
  id: string;
  username: string;
  label: string;
  imageUrl?: string;
};

/**
 * Hook to get user's organizations
 */
export const useUserOrganizations = () => {
  const { user } = useAuth();
  const [accounts, setAccounts] = useState<Record<string, Account>>({});
  const [isLoading, setIsLoading] = useState(true);

  const getAccounts = useCallback(async () => {
    if (!user) return {};

    const { organizationMemberships } =
      await userClient.getOrganizationMemberships({
        userId: user.uid,
      });

    const userMembershipAccounts: Record<string, Account> =
      organizationMemberships?.reduce(
        (acc, membership) => ({
          ...acc,
          [membership.organizationId]: {
            id: membership.organizationId,
            label: membership.organizationName,
            username: membership.organizationSlug,
            imageUrl: membership.organizationImageUrl,
          },
        }),
        {},
      );

    return userMembershipAccounts;
  }, [user]);

  useEffect(() => {
    getAccounts().then((accounts) => {
      setAccounts(accounts);
      setIsLoading(false);
    });
  }, [getAccounts]);

  return {
    data: accounts,
    isLoading,
    orgCount: Object.keys(accounts).length,
  };
};
